// extracted by mini-css-extract-plugin
export default {"splashStyle":"PayNowOverview_splashStyle__t4xt4"};